import React, {Component} from 'react';
import * as Sentry from '@sentry/browser';
import BgPic from './images/sections/not-found/bg.png';
import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';
import {MODAL_TYPE, showModal} from './forecast-app/shared/components/modals/generic_modal_conductor';
import 'whatwg-fetch'; //IE 11 fetch polyfill

class ErrorBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = {error: null};
	}

	componentDidCatch(error, errorInfo) {
		if (this.props.modal) {
			showModal({
				type: MODAL_TYPE.BOUNDARY_ERROR,
				modalType: this.props.modalType,
			});
		}

		const errorId = Sentry.captureException(error);
		// eslint-disable-next-line no-console
		console.log(error);

		const init = {credentials: 'include'};

		let options = '?url=' + encodeURI(window.location.pathname);

		if (errorId) {
			options += `&sentryEventId=${errorId}`;
		}

		fetch(process.env.GRAPHQL_ENDPOINT.slice(0, -7) + 'error_modal_shown' + options, init);
		this.setState({error});
	}

	reload() {
		window.location.href = '/';
	}

	render() {
		if (this.state.error) {
			//render fallback UI
			if (this.props.modal) {
				return null;
			}
			if (this.props.header) {
				return <div>Menu unavailable</div>;
			}
			return (
				<div className="error-boundary">
					<div className="text-container">
						<h1>
							<FormattedMessage id="not_found.header" />
						</h1>
						<p>
							<FormattedMessage id="error_boundary.message1" />
						</p>
						<p>
							<FormattedHTMLMessage id="error_boundary.message2" />
						</p>
						{this.props.showReloadButton ? (
							<button className="reload-button" onClick={this.reload}>
								<FormattedMessage id="modal.new_version_available.header.button" />
							</button>
						) : null}
					</div>
					<div className="image-container">
						<img src={BgPic} alt="" />
					</div>
				</div>
			);
		} else {
			//when there's not an error, render children untouched
			return this.props.children;
		}
	}
}

export default ErrorBoundary;
